
import * as React from 'react';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { DataGrid } from '@process-advisor/process-miner/modals/detail/dataGrid';
import { taskSummaryGridColumns } from '@process-advisor/process-miner/modals/detail/taskDetail/taskSummaryGridColumns';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'

type Row = {};


const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let attribute = '';

let optionsAttributes = [];

export const TaskSummaryGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);
    const [columns, setColumns] = React.useState<ColDef[]>();

    useApiListener(
        Event.updateTasks,
        () => setData(apiProvider.analyticsTaskAttributes())
    );
    useApiListener(
        Event.updateTaskAttributes,
        () => taskAttributes()
    );

    React.useEffect(() => {
        setColumns(taskSummaryGridColumns())
    }, []);

    React.useEffect(() => {
        taskAttributes();
        const temp = apiProvider.getDetailTaskSummaryAttribute()
        if (temp['attribute'] != '') {
            attribute = temp['attribute']
        }
        apiProvider.setTaskDetailExtract({type: 'summary'})
        setData(apiProvider.processDetailTaskSummary());
    }, []);

    const onAttributeChange = (attributeSelected: string) => {
        attribute = attributeSelected;
        apiProvider.changeDetailTaskSummaryAttribute({ attribute });
        setData(apiProvider.processDetailTaskSummary());
    };

    const taskAttributes = () => {
        optionsAttributes = [];
        const tOptions = apiProvider.taskAttributes({});
        for (const each of tOptions) {
            const valueToPush = { value: each.value, label: each.label };
            optionsAttributes.push(valueToPush);
        }
        if (optionsAttributes.length > 0 ) {
            attribute = optionsAttributes[0].value;
        }
    };
    const rows = data.map((row, id) => ({ id, ...row }));
    
    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Group by:'/>
            </SingleBlock>
            <SingleBlock width="90%">
                <Dropdown
                    options={optionsAttributes}
                    onChange={onAttributeChange}
                    value={attribute}/>
            </SingleBlock>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'summary'}
                height="550px" />

        </Wrapper>
    );
};
